import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]

  switchTab(event) {
    event.preventDefault()
    const perspective = event.currentTarget.dataset.perspective

    this.tabTargets.forEach(tab => {
      const selected = tab.dataset.perspective === perspective
      tab.setAttribute("aria-pressed", selected)

      if (selected) {
        tab.classList.remove("text-zinc-600", "hover:text-zinc-800")
        tab.classList.add("bg-white", "text-black", "shadow", "font-medium")
      } else {
        tab.classList.remove("bg-white", "text-black", "shadow", "font-medium")
        tab.classList.add("text-zinc-600", "hover:text-zinc-800")
      }
    })

    this.contentTargets.forEach(content => {
      if (content.dataset.perspective === perspective) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
